!(function () {
    "use strict";
    function e(e) {
        var t = !0,
            n = !1,
            o = null,
            s = { text: !0, search: !0, url: !0, tel: !0, email: !0, password: !0, number: !0, date: !0, month: !0, week: !0, time: !0, datetime: !0, "datetime-local": !0 };
        function i(e) {
            return !!(e && e !== document && "HTML" !== e.nodeName && "BODY" !== e.nodeName && "classList" in e && "contains" in e.classList);
        }
        function a(e) {
            e.classList.contains("focus-visible") || (e.classList.add("focus-visible"), e.setAttribute("data-focus-visible-added", ""));
        }
        function r(e) {
            t = !1;
        }
        function c() {
            document.addEventListener("mousemove", d),
                document.addEventListener("mousedown", d),
                document.addEventListener("mouseup", d),
                document.addEventListener("pointermove", d),
                document.addEventListener("pointerdown", d),
                document.addEventListener("pointerup", d),
                document.addEventListener("touchmove", d),
                document.addEventListener("touchstart", d),
                document.addEventListener("touchend", d);
        }
        function d(e) {
            (e.target.nodeName && "html" === e.target.nodeName.toLowerCase()) ||
                ((t = !1),
                    document.removeEventListener("mousemove", d),
                    document.removeEventListener("mousedown", d),
                    document.removeEventListener("mouseup", d),
                    document.removeEventListener("pointermove", d),
                    document.removeEventListener("pointerdown", d),
                    document.removeEventListener("pointerup", d),
                    document.removeEventListener("touchmove", d),
                    document.removeEventListener("touchstart", d),
                    document.removeEventListener("touchend", d));
        }
        document.addEventListener(
            "keydown",
            function (n) {
                n.metaKey || n.altKey || n.ctrlKey || (i(e.activeElement) && a(e.activeElement), (t = !0));
            },
            !0
        ),
            document.addEventListener("mousedown", r, !0),
            document.addEventListener("pointerdown", r, !0),
            document.addEventListener("touchstart", r, !0),
            document.addEventListener(
                "visibilitychange",
                function (e) {
                    "hidden" === document.visibilityState && (n && (t = !0), c());
                },
                !0
            ),
            c(),
            e.addEventListener(
                "focus",
                function (e) {
                    var n, o, r;
                    i(e.target) && (t || ((n = e.target), (o = n.type), ("INPUT" === (r = n.tagName) && s[o] && !n.readOnly) || ("TEXTAREA" === r && !n.readOnly) || n.isContentEditable)) && a(e.target);
                },
                !0
            ),
            e.addEventListener(
                "blur",
                function (e) {
                    var t;
                    i(e.target) &&
                        (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) &&
                        ((n = !0),
                            window.clearTimeout(o),
                            (o = window.setTimeout(function () {
                                n = !1;
                            }, 100)),
                            (t = e.target).hasAttribute("data-focus-visible-added") && (t.classList.remove("focus-visible"), t.removeAttribute("data-focus-visible-added")));
                },
                !0
            ),
            e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.host
                ? e.host.setAttribute("data-js-focus-visible", "")
                : e.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }
    if ("undefined" != typeof window && "undefined" != typeof document) {
        var t;
        window.applyFocusVisiblePolyfill = e;
        try {
            t = new CustomEvent("focus-visible-polyfill-ready");
        } catch (e) {
            (t = document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
        }
        window.dispatchEvent(t);
    }
    var n;
    function o(e) {
        return (
            (o =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (e) {
                        return typeof e;
                    }
                    : function (e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }),
            o(e)
        );
    }
    "undefined" != typeof document && e(document),
        window.NodeList &&
        !NodeList.prototype.forEach &&
        (NodeList.prototype.forEach = function (e, t) {
            t = t || window;
            for (var n = 0; n < this.length; n++) e.call(t, this[n], n, this);
        }),
        ((n = Element.prototype).matches = n.matches || n.mozMatchesSelector || n.msMatchesSelector || n.oMatchesSelector || n.webkitMatchesSelector),
        (n.closest =
            n.closest ||
            function (e) {
                return this ? (this.matches(e) ? this : this.parentElement ? this.parentElement.closest(e) : null) : null;
            });
    var s = function (e, t) {
        var n,
            s,
            i,
            a,
            r,
            c,
            d,
            l = { baseClass: "select", onInit: function () { }, onBeforeOpen: function () { }, onOpen: function () { }, onBeforeClose: function () { }, onClose: function () { }, onBeforeChange: function () { }, onChange: function () { } };
        function u() {
            return i && i.classList.contains("is-initialized");
        }
        function m() {
            if (d)
                for (; d.firstChild;) {
                    var e = d.firstChild;
                    e.removeEventListener("click", h, !1), e.removeEventListener("mousemove", h, !1), e.removeEventListener("keydown", h, !1), d.removeChild(e);
                }
        }
        function v() {
            if (i) {
                for (var e = document.createDocumentFragment(), t = s.options, o = 0, a = t.length; o < a; o++) {
                    var c = t[o],
                        l = c.hasAttribute("selected"),
                        u = document.createElement("li");
                    u.classList.add(n.baseClass + "__item"),
                        u.setAttribute("role", "option"),
                        u.setAttribute("data-value", c.value),
                        u.setAttribute("tabindex", "-1"),
                        u.setAttribute("aria-selected", l),
                        (u.innerHTML = c.innerHTML),
                        l && (u.classList.add("is-selected"), (r.innerHTML = t[o].innerHTML)),
                        "" === c.value && ((u.style.display = "none"), i.classList.add(n.baseClass + "--placeholder")),
                        u.addEventListener("click", h, !1),
                        u.addEventListener("mousemove", h, !1),
                        u.addEventListener("keydown", h, !1),
                        e.appendChild(u);
                }
                m(), d.appendChild(e);
            }
        }
        function f(e) {
            var t = s.selectedIndex,
                o = [].indexOf.call(d.children, e);
            t != o &&
                (d.querySelectorAll('[aria-selected="true"]').forEach(function (e) {
                    e.setAttribute("aria-selected", "false"), e.classList.remove("is-selected");
                }),
                    e.setAttribute("aria-selected", "true"),
                    e.classList.add("is-selected"),
                    (r.innerHTML = s.options[o].innerHTML),
                    i.classList.remove(n.baseClass + "--placeholder"),
                    (s.selectedIndex = o),
                    s.dispatchEvent(new Event("input", { bubbles: !0 })),
                    s.dispatchEvent(new Event("change", { bubbles: !0 })));
        }
        function p(e) {
            if (("click" === e.type && (i.classList.contains("is-open") ? w() : y(), e.preventDefault(), e.stopImmediatePropagation()), "keydown" === e.type)) {
                var t = !0;
                switch (e.key) {
                    case "ArrowUp":
                    case "ArrowDown":
                    case "Enter":
                    case " ":
                        y();
                        break;
                    case "Tab":
                        t = !1;
                }
                t && e.preventDefault();
            }
        }
        function b(e) {
            return "none" === window.getComputedStyle(e).display;
        }
        function E() {
            for (var e = d.firstElementChild; e && b(e);) e = e.nextElementSibling;
            return e;
        }
        function h(e) {
            var t = e.target;
            if (("click" === e.type && (f(t), w(), a.focus()), "mousemove" === e.type && t.focus(), "keydown" === e.type)) {
                var o = !0;
                switch (e.key) {
                    case "ArrowUp":
                    case "ArrowLeft":
                        var s = (function (e) {
                            for (var t = e.previousElementSibling; t && b(t);) t = t.previousElementSibling;
                            return t;
                        })(t);
                        s && s.focus();
                        break;
                    case "ArrowDown":
                    case "ArrowRight":
                        var r = (function (e) {
                            for (var t = e.nextElementSibling; t && b(t);) t = t.nextElementSibling;
                            return t;
                        })(t);
                        r && r.focus();
                        break;
                    case "Home":
                        var c = E();
                        c && c.focus();
                        break;
                    case "End":
                        var l = (function () {
                            for (var e = d.lastElementChild; e && b(e);) e = e.previousElementSibling;
                            return e;
                        })();
                        l && l.focus();
                        break;
                    case "PageUp":
                    case "PageDown":
                        break;
                    case "Tab":
                        i.classList.contains(n.baseClass + "--placeholder") || f(t), w(), (o = !1);
                        break;
                    case "Enter":
                    case " ":
                        f(t);
                    case "Escape":
                        w(), a.focus();
                }
                o && e.preventDefault();
            }
        }
        function L(e) {
            if ("click" === e.type) {
                var t = e.target;
                i && i.classList.contains("is-open") && t !== i && !i.contains(t) && (e.stopPropagation(), w());
            }
        }
        function y() {
            n.onBeforeOpen;
            a.getBoundingClientRect();
            var e = d.querySelector('[aria-selected="true"]');
            (e && !b(e)) || (e = E()),
                i.classList.add("is-open"),
                a.setAttribute("aria-expanded", "true"),
                e.focus(),
                (function () {
                    var e = a.getBoundingClientRect();
                    i.classList.remove(n.baseClass + "--top"), e.y + e.height + c.offsetHeight > document.documentElement.clientHeight && i.classList.add(n.baseClass + "--top");
                })(),
                n.onOpen;
        }
        function w() {
            n.onBeforeClose, i.classList.remove("is-open"), a.setAttribute("aria-expanded", "false"), n.onClose;
        }
        function C() {
            u() &&
                (document.removeEventListener("click", L, !0),
                    m(),
                    i.removeChild(c),
                    a.removeEventListener("click", p, !1),
                    a.removeEventListener("keydown", p, !1),
                    i.removeChild(a),
                    i.parentNode.insertBefore(s, i),
                    i.parentNode.removeChild(i),
                    (n = null));
        }
        function g() {
            if (!u()) {
                if (!("querySelector" in document && "addEventListener" in window && "requestAnimationFrame" in window && "closest" in window.Element.prototype))
                    throw "select: This browser does not support the required JavaScript methods and browser APIs.";
                if ((C(), "string" == typeof e ? (s = document.querySelector(e)) : "object" === o(e) && (s = e), !s)) throw "select: Does not found a select control!";
                (n = (function (e, t) {
                    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    return e;
                })(l, t || {})),
                    (function () {
                        (i = document.createElement("div")).classList.add(n.baseClass),
                            s.parentNode.insertBefore(i, s),
                            s.setAttribute("tabindex", "-1"),
                            i.appendChild(s),
                            (a = document.createElement("button")).classList.add(n.baseClass + "__button"),
                            i.appendChild(a),
                            (r = document.createElement("span")).classList.add(n.baseClass + "__button-caption");
                        var e = s.getAttribute("data-label") || "";
                        if (e) {
                            var t = document.createElement("span");
                            t.classList.add(n.baseClass + "__button-text"), a.appendChild(t);
                            var o = document.createElement("span");
                            o.classList.add(n.baseClass + "__button-label"), (o.textContent = e), t.appendChild(o), t.appendChild(r);
                        } else a.appendChild(r);
                        var l = document.createElement("span");
                        l.classList.add(n.baseClass + "__button-arrow"),
                            a.appendChild(l),
                            a.setAttribute("aria-disabled", s.disabled),
                            a.addEventListener("click", p, !1),
                            a.addEventListener("keydown", p, !1),
                            (c = document.createElement("div")).classList.add(n.baseClass + "__dropdown"),
                            i.appendChild(c),
                            (d = document.createElement("ul")).setAttribute("role", "listbox"),
                            d.classList.add(n.baseClass + "__items"),
                            c.appendChild(d);
                    })(),
                    v(),
                    document.addEventListener("click", L, !0),
                    i.classList.add("is-initialized"),
                    n.onInit;
            }
        }
        g();
        var A = {};
        return (
            (A.init = g),
            (A.destroy = C),
            (A.update = function () {
                u && v();
            }),
            (A.open = y),
            (A.close = w),
            A
        );
    };
    !(function () {
        var e = document.querySelector(".ws-geo");
        if (!e) return !1;
        var t = e.querySelector(".ws-geo__select select");
        if (!t) return !1;
        var n = e.querySelector(".ws-map svg");
        function o(t) {
            e.querySelectorAll(".ws-geo__card").forEach(function (e) {
                e.classList.remove("active");
            });
            var o = e.querySelector('.ws-geo__card[data-region="' + t.toUpperCase() + '"]');
            o && o.classList.add("active"),
                n.querySelectorAll("path").forEach(function (e) {
                    e.classList.remove("active");
                }),
                n.querySelectorAll('path[data-region="' + t.toUpperCase() + '"]').forEach(function (e) {
                    e.classList.add("active");
                });
        }
        (new s(t, { baseClass: "ws-select" }),
            t.addEventListener("change", function (e) {
                o(t.value);
            }),
            n.querySelectorAll("path").forEach(function (e) {
                var t = e.hasAttribute("data-region") ? e.getAttribute("data-region") : "";
                e.addEventListener("mouseenter", function () {
                    o(t);
                }),
                    e.addEventListener("click", function () {
                        o(t);
                    });
            }),
            (window.innerWidth || document.documentElement.clientWidth) >= 1e3) && ("ru" == (document.documentElement.getAttribute("lang") || "en").toLowerCase() ? o("RU") : o("US"));
    })();
})();
$(".btn-collectgetprice").on("click", function () {
    $.magnificPopup.open({
        items: {
            src: "#getprice_popup",
        },
        type: "inline",
        midClick: true,
        mainClass: "mfp-zoom-in popup-collectgetprice",
        fixedContentPos: true,
        fixedBgPos: true,
        removalDelay: 300,
        showCloseBtn: false,
        closeBtnInside: false,
        closeOnBgClick: false,
        enableEscapeKey: true,
        callbacks: {
            ajaxContentAdded: function () {
                /*var maskedEmail = IMask(
                    document.getElementById('cb-email'), {
                        mask: /^\S*@?\S*$/
                    });*/

                var ev = new Event("mpop_contentReady");
                el = $(this.content)[0];
                document.dispatchEvent(ev);
            },
        },
    });
    return false;
});
$(document).on("click", ".popup--collectgetprice-form .js-popup-close", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
    return false;
});
$(document).delegate(".sendform form", "submit", function (evt) {
    evt.preventDefault();
});

const sendCollectgetpriceForm = (page = false) => {
    if (page == "corporate") {
        subject = "Запрос стр. корпорат. - unidragon.com";
        formid = 5;
    } else {
        formid = 4;
        subject = "Запрос прайса - unidragon.com";
    }

    button = $(".collectgetprice-form__button");

	if (!button.length) {
		button = $("[data-corporate-form-button]");
	}

	console.log(button)
	$(".contact-form .warning").remove();

    /*
    $('#email_error').remove();
    var mail = $('.contact-form #email').val();
    if (!regMail(mail)) {
        button.after("<span id='email_error' style='color:red;'>Укажите email</span>");
        return false;
    }*/

    const getUTMs = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const expected = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
        const utms = {};
        expected.map((e) => {
            if (urlParams.get(e)) {
                utms[e] = urlParams.get(e);
            }
        });
        return utms;
    };
    const emailInput = document.querySelector('[data-corporate-form] input[name="contact[email]"]') || document.querySelector('[data-corporate-form] input[name="email"]');
    let emailInputValue = emailInput.value;
    const phoneInput = document.querySelector('[data-corporate-form] input[name="contact[phone]"]') || document.querySelector('[data-corporate-form] input[name="telephone"]');
    let phoneInputValue = phoneInput.value;
    const nameInput = document.querySelector('[data-corporate-form] input[name="contact[name]"]') || document.querySelector('[data-corporate-form] input[name="name"]');
    let nameInputValue = nameInput.value;
	const messageInput = document.querySelector('[data-corporate-form] textarea[name="contact[message]"]') || document.querySelector('[data-corporate-form] textarea[name="message"]')
	let messageInputValue = messageInput.value;
	const cityInput = document.querySelector('[data-corporate-form] input[name="contact[city]"]') || document.querySelector('[data-corporate-form] input[name="city"]') || document.querySelector('[data-corporate-form] input[name="country"]')
	let cityInputValue = cityInput.value;

    let postData = {
        formid: formid, // 4 - Запрос прайса // 5 корпорат.
        token: "De2IeDoy6aihat4aeCh3Aith4Eiquo3O",
        firstName: nameInputValue,
        phone: phoneInputValue,
        email: emailInputValue,
        country: cityInputValue,
        business_type: document.querySelector('.contact-form select[name="business_type"]')?.value,
        message: messageInputValue,
        leadName: subject,
        lang: "en"
    };
    const utms = getUTMs();
    if (Object.keys(utms).length) {
        postData.utms = utms;
    }
    if (emailInputValue.includes("@")) {
        fetch("https://unidragon.ru/index.php?route=api/amocrm/saveAmo", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
        referrerPolicy: "strict-origin-when-cross-origin",
        body: JSON.stringify(postData),
    })
        .then((r) => r.json())
        .then((json) => {
            if (json["response"]["status"] == "ok") {
                button.html("Successfully sent");
                setTimeout(function () {
                    $.magnificPopup.close();
                }, 3000);
				button.parent().append('<div class="success">Successfully sent</div>');
            }
            if (json["response"]["error"]) {
                warning = '<div class="warning">' + json["response"]["error"] + "</div>";
                if ($(window).width() < 740) {
                    button.parent().prepend(warning);
                } else {
                    button.parent().append(warning);
                }
            }
        });
    }

    return false;
};
